<template>
  <div>
    <div class="air__utils__heading">
      <div class="row">
        <div class="col-6">
          <h5>Tuition Monthly Attendance Report</h5>
        </div>
      </div>
    </div>

    <div class="row justify-content-center" v-if="pagepermission.viewable">
      <div class="col-xl-12">
        <!-- Filters -->
        <div class="row mb-3">
          <!-- Program Filter -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedProgramId"
              placeholder="Select Program"
              show-search
              style="width: 100%"
              :filter-option="filterOption"
              @change="handleProgramChange"
            >
              <a-select-option v-for="p in programs" :key="p.id" :value="p.id">
                {{ p.name }}
                <small class="text-muted" v-if="p.code">({{ p.code }})</small>
              </a-select-option>
            </a-select>
          </div>
          <!-- Tuition Session -->
          <div class="col-md-3 col-12 mb-2">
            <a-select
              size="large"
              v-model="selectedTuitionSessionId"
              placeholder="Select Tuition Session"
              style="width: 100%"
              :disabled="!selectedProgramId"
              @change="handleSessionChange"
            >
              <a-select-option v-for="s in tuitionSessions" :key="s.id" :value="s.id">
                {{ s.name }}
              </a-select-option>
            </a-select>
          </div>
          <!-- Date Range -->
          <div class="col-md-5 col-12 mb-2">
            <a-range-picker
              size="large"
              style="width: 100%"
              v-model="dateRange"
              :format="dateFormat"
              :disabled-date="disabledDate"
              @change="handleDateRangeChange"
            />
          </div>
        </div>

        <!-- Report Table Component -->
        <div class="card">
          <div class="card-body">
            <tuition-report-table
              v-if="reportData"
              :loading="loading"
              :data="reportData.data || []"
              :sessionInfo="reportData.tuition_session"
              :startDate="reportData.start_date"
              :endDate="reportData.end_date"
              :totalDays="reportData.total_days"
            />
            <div v-else-if="!loading" class="text-center py-5">
              <a-empty description="Select a tuition session and date range to view report" />
            </div>
            <a-spin v-else />
          </div>
        </div>
      </div>
    </div>
    <div class="row justify-content-center" v-else>
      <p class="error">
        You don't have permission to use this feature.
      </p>
    </div>
  </div>
</template>

<script>
import moment from 'moment'
import TuitionReportTable from '@/components/tuition/manage/attendance/ReportTable'

export default {
  name: 'TuitionMonthlyAttendanceReport',
  components: {
    TuitionReportTable,
  },
  beforeMount() {
    this.$roleutility.checkpermission('tuition-attendance-report', 22).then(data => {
      this.pagepermission = data.pagePermission
    })
  },
  data() {
    return {
      loading: false,
      dateFormat: 'DD-MM-YYYY',

      programs: [],
      tuitionSessions: [],
      selectedProgramId: undefined,
      selectedTuitionSessionId: undefined,
      dateRange: [moment().startOf('month'), moment()],

      reportData: null,
      pagepermission: {
        insertable: false,
        editable: false,
        viewable: false,
        deletable: false,
      },
    }
  },
  mounted() {
    this.fetchPrograms()
  },
  methods: {
    moment,
    disabledDate(current) {
      // Can not select days after today
      return current && current > moment().endOf('day')
    },
    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    fetchPrograms() {
      this.$http.get('/api/tuition/programs')
        .then(({ data }) => {
          this.programs = data.data || data
        })
    },
    handleProgramChange(value) {
      this.selectedProgramId = value
      this.selectedTuitionSessionId = undefined
      this.tuitionSessions = []
      this.reportData = null

      if (value) {
        this.$http.get(`/api/tuition/programs/${value}/sessions`)
          .then(({ data }) => {
            this.tuitionSessions = data.data || data
          })
      }
    },
    handleSessionChange() {
      if (this.selectedTuitionSessionId && this.dateRange && this.dateRange.length === 2) {
        this.fetchReport()
      }
    },
    handleDateRangeChange() {
      if (this.selectedTuitionSessionId && this.dateRange && this.dateRange.length === 2) {
        this.fetchReport()
      }
    },
    fetchReport() {
      if (!this.selectedTuitionSessionId || !this.dateRange || this.dateRange.length !== 2) {
        this.$message.warning('Please select a tuition session and a date range.')
        return
      }
      this.loading = true
      this.$http.get('/api/tuition/attendance/report', {
        params: {
          tuition_session_id: this.selectedTuitionSessionId,
          start_date: moment(this.dateRange[0]).format('YYYY-MM-DD'),
          end_date: moment(this.dateRange[1]).format('YYYY-MM-DD'),
        },
      })
        .then(({ data }) => {
          this.reportData = data
        })
        .catch(error => {
          this.$neoNotify.error(error)
        })
        .finally(() => {
          this.loading = false
        })
    },
  },
}
</script>
